import { render, staticRenderFns } from "./addressform.vue?vue&type=template&id=0ec3cfbd"
import script from "./addressform.vue?vue&type=script&lang=js"
export * from "./addressform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports